export const DASHBOARD_LOAN_DOCUMENTS = [
  {
    id: '0',
    name: 'Loan terms ',
  },
  {
    id: '1',
    name: 'Signed loan package',
  },
  {
    id: '2',
    name: 'Docs E Communications',
  },
  {
    id: '3',
    name: 'ATIL',
  },
]

export const DASHBOARD_APPLICATION_DETAILS = [
  { id: '0', name: 'Eligibility', progress: 100 },
  { id: '1', name: 'Personal info', progress: 100 },
  { id: '2', name: 'Education info', progress: 100 },
  { id: '3', name: 'Employment info', progress: 100 },
  { id: '4', name: 'Financial info', progress: 100 },
]

export const DASHBOARD_LOAD_TERMS = [
  { title: 'XX% (xx%)', text: 'Interest rate (APR)' },
  { title: '2%', text: 'Origination free' },
  { title: '10 years', text: 'Term' },
  { title: 'US$50,000', text: 'Total amount financed' },
  { title: 'US$5,000', text: 'In-school payment amount' },
]

export enum ApplicationStep {
  INCOMPLETE_APPLICATION_PERSONAL = 'incomplete-application-personal',
  INCOMPLETE_APPLICATION_PREQUAL = 'incomplete-application-prequal',
  INCOMPLETE_APPLICATION_PERSONAL_ACCEPT = 'incomplete-application-personal-accept',
  INCOMPLETE_APPLICATION_PERSONAL_REJECT = 'incomplete-application-personal-reject',
  INCOMPLETE_APPLICATION_EDUCATION = 'incomplete-application-education',
  INCOMPLETE_APPLICATION_EMPLOYMENT = 'incomplete-application-employment',
  INCOMPLETE_APPLICATION_FINANCE = 'incomplete-application-financial',
  INCOMPLETE_APPLICATION_FINAL_SUBMIT = 'incomplete-application-final',
  CONFIRM_LOAN_AMOUNT_UPSELL = 'confirm-loan-amount-upsell',
  CONFIRM_LOAN_AMOUNT_FULL = 'confirm-loan-amount-full',
  CONFIRM_LOAN_AMOUNT_PARTIAL = 'confirm-loan-amount-partial',
  ADDITIONAL_FUNDING = 'additional-funding',
  ACADEMIC_PERIOD = 'academic-period',
  ID_VERIFICATION = 'id-verification',
  CREDIT_CHECK = 'credit-check',
  UPLOAD_DOCUMENTS = 'upload-documents',
  NOVA_CASHFLOW = 'nova-cashflow',
  UPDATE_PROFILE = 'update-profile',
  UPLOAD_ADMISSION_LETTER = 'upload-admission-letter',
  RE_UPLOAD_DOCUMENTS = 're-upload-documents',
  KICKBACK = 'kickback',
  DOCUMENT_VERIFICATION = 'document-verification',
  SUPPORT_LETTER = 'support-letter',
  FINAL_REVIEW = 'final-review',
  ACCEPT_LOAN = 'accept-loan',
  ACCEPT_LOAN_TIL = 'accept-loan-til',
  SCHOOL_CERTIFICATION = 'school-certification',
  UPLOAD_VISA = 'upload-visa',
  TRANSFER_DOCUMENT = 'transfer-document',
  REVIEW_AND_SIGN_LOAN = 'review-and-sign-loan',
  FINAL_DISCLOSURE = 'final-disclosure',
  FUNDING_IN_PROGRESS = 'funding-in-progress',
  INCOMPLETE_APPLICATION_TAS = 'incomplete-application',
  PAYOFF = 'payoff',
  PAYOFF_VERIFICATION = 'payoff-verification',
  UPLOAD_TUITION_BILL = 'upload-tuition-bill',
}

export enum ApplicationCountry {
  UNITED_STATE = 'United States',
  CANADA = 'Canada',
}

export interface ApplicationStepText {
  status: string
  action: string
  workingOn: string
  color?: string
}

type ApplicationStepTextMap = Record<
  ApplicationStep,
  ApplicationStepText | Record<ApplicationCountry, ApplicationStepText>
>

export const APPLICATION_STEP_TEXT: ApplicationStepTextMap = {
  [ApplicationStep.INCOMPLETE_APPLICATION_TAS]: {
    status: '',
    action: '',
    workingOn: '',
  },
  [ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL]: {
    status: 'Complete application',
    action: 'Complete Now',
    workingOn: 'Complete application',
  },
  [ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL_REJECT]: {
    status: 'Complete application',
    action: 'Complete Now',
    workingOn: 'Complete application',
  },
  [ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL_ACCEPT]: {
    status: 'Complete application',
    action: 'Complete Now',
    workingOn: 'Complete application',
  },
  [ApplicationStep.INCOMPLETE_APPLICATION_PREQUAL]: {
    status: 'Complete application',
    action: 'Complete Now',
    workingOn: 'Complete application',
  },
  [ApplicationStep.INCOMPLETE_APPLICATION_EDUCATION]: {
    status: 'Complete application',
    action: 'Complete Now',
    workingOn: 'Complete application',
  },
  [ApplicationStep.INCOMPLETE_APPLICATION_EMPLOYMENT]: {
    status: 'Complete application',
    action: 'Complete Now',
    workingOn: 'Complete application',
  },
  [ApplicationStep.INCOMPLETE_APPLICATION_FINANCE]: {
    status: 'Complete application',
    action: 'Complete Now',
    workingOn: 'Complete application',
  },
  [ApplicationStep.INCOMPLETE_APPLICATION_FINAL_SUBMIT]: {
    status: 'Complete application',
    action: 'Complete Now',
    workingOn: 'Complete application',
  },
  [ApplicationStep.CONFIRM_LOAN_AMOUNT_UPSELL]: {
    status: 'Confirm loan amount',
    action: 'Complete Now',
    workingOn: 'Confirm loan amount',
  },
  [ApplicationStep.CONFIRM_LOAN_AMOUNT_FULL]: {
    status: 'Confirm loan amount',
    action: 'Complete Now',
    workingOn: 'Confirm loan amount',
  },
  [ApplicationStep.CONFIRM_LOAN_AMOUNT_PARTIAL]: {
    status: 'Confirm loan amount',
    action: 'Complete Now',
    workingOn: 'Confirm loan amount',
  },
  [ApplicationStep.ADDITIONAL_FUNDING]: {
    status: 'Additional Funding',
    action: 'Complete Now',
    workingOn: 'Additional Funding',
  },
  [ApplicationStep.ACADEMIC_PERIOD]: {
    status: 'Confirm academic period',
    action: 'Complete Now',
    workingOn: 'Confirm academic period',
  },
  [ApplicationStep.ID_VERIFICATION]: {
    status: 'Verify identity',
    action: 'Complete Now',
    workingOn: 'Verify identity',
  },
  [ApplicationStep.CREDIT_CHECK]: {
    status: 'Home country credit check',
    action: 'Complete Now',
    workingOn: 'Home country credit check',
  },
  [ApplicationStep.NOVA_CASHFLOW]: {
    status: 'Verify U.S bank details',
    action: 'Complete Now',
    workingOn: 'Verify U.S bank details',
  },
  [ApplicationStep.UPLOAD_ADMISSION_LETTER]: {
    status: 'Upload proof of program of study',
    action: 'Complete Now',
    workingOn: 'Upload proof of program of study',
  },
  [ApplicationStep.UPLOAD_DOCUMENTS]: {
    status: 'Upload documents for verification',
    action: 'Complete Now',
    workingOn: 'Upload documents for verification',
  },
  [ApplicationStep.RE_UPLOAD_DOCUMENTS]: {
    status: 'Upload documents for verification',
    action: 'Complete Now',
    workingOn: 'Upload documents for verification',
  },
  [ApplicationStep.KICKBACK]: {
    status: 'Mismatched',
    action: 'Complete Now',
    workingOn: 'Incomplete / Mismatched documents',
    color: '#F05A37',
  },
  [ApplicationStep.UPLOAD_TUITION_BILL]: {
    status: 'Forbearance',
    action: 'Complete Now',
    workingOn: 'Upload tuition bill',
    color: '#FFAF0F',
  },
  [ApplicationStep.DOCUMENT_VERIFICATION]: {
    status: 'Under Review',
    action: 'View Application',
    workingOn: 'Document Verification',
  },
  [ApplicationStep.SUPPORT_LETTER]: {
    status: 'Under Review',
    action: 'View Application',
    workingOn: `You're at final review`,
  },
  [ApplicationStep.FINAL_REVIEW]: {
    status: 'Under Review',
    action: 'View Application',
    workingOn: `You're at final review`,
  },
  [ApplicationStep.ACCEPT_LOAN]: {
    status: 'Accept Loan terms',
    action: 'Complete Now',
    workingOn: 'Accept Loan terms',
  },
  [ApplicationStep.ACCEPT_LOAN_TIL]: {
    status: 'Finalize Loan terms',
    action: 'Complete Now',
    workingOn: 'Finalize Loan terms',
  },
  [ApplicationStep.SCHOOL_CERTIFICATION]: {
    status: 'School Certification',
    action: 'View Application',
    workingOn: 'School Certification',
  },
  [ApplicationStep.UPLOAD_VISA]: {
    'United States': {
      status: 'Upload Visa',
      action: 'Complete Now',
      workingOn: 'Upload Visa',
    },
    Canada: {
      status: 'Upload Letter of Introduction/Study Permit',
      action: 'Complete Now',
      workingOn: 'Upload Letter of Introduction/Study Permit',
    },
  },
  [ApplicationStep.TRANSFER_DOCUMENT]: {
    status: 'Upload Credit Transfer Document',
    action: 'Complete Now',
    workingOn: 'Upload Credit Transfer Document',
  },
  [ApplicationStep.REVIEW_AND_SIGN_LOAN]: {
    status: 'Your loan documents',
    action: 'Complete Now',
    workingOn: 'Your loan documents',
  },
  [ApplicationStep.FINAL_DISCLOSURE]: {
    'United States': {
      status: 'Final Disclosure',
      action: 'View Application',
      workingOn: 'Final Disclosure',
    },
    Canada: {
      status: 'Final Disclosure',
      action: 'View Application',
      workingOn: 'Final Disclosure',
    },
  },
  [ApplicationStep.UPDATE_PROFILE]: {
    status: 'Update profile',
    action: 'Complete Now',
    workingOn: 'Profile Update',
  },
  [ApplicationStep.FUNDING_IN_PROGRESS]: {
    status: 'Completed',
    action: 'View Application',
    workingOn: 'Application Completed',
  },
  [ApplicationStep.PAYOFF]: {
    status: 'Upload Payoff Statement',
    action: 'Complete Now',
    workingOn: 'Payoff Details',
  },
  [ApplicationStep.PAYOFF_VERIFICATION]: {
    status: 'Under Review',
    action: 'View Application',
    workingOn: 'Payoff Details',
  },
} as const

export enum InactiveApplicationStatus {
  BORROWER_CREDIT_DECLINED = 'Borrower Credit Declined',
  BORROWED_APPLICATION = 'Borrower Application Expired',
  LOAN_OFFER_EXPIRED = 'Loan Offer Expired',
  APPLICATION_CANCELED = 'Application Canceled',
  LOAN_WITHDRAWN = 'Loan Withdrawn',
  LOAN_CANCELED = 'Loan Canceled',
  NOT_ELIGIBLE = 'Not Eligible',
  NON_ELIGIBLE = 'Non-Eligible',
  PAID_IN_FULL = 'Paid in Full',
}

type InactiveApplicationStatusText = {
  status: string
  state: 'denied' | 'completed'
}
export const INACTIVE_APPLICATION_STATUSES: Record<
  InactiveApplicationStatus,
  InactiveApplicationStatusText
> = {
  [InactiveApplicationStatus.BORROWER_CREDIT_DECLINED]: {
    status: 'Denied',
    state: 'denied',
  },
  [InactiveApplicationStatus.BORROWED_APPLICATION]: {
    status: 'Expired',
    state: 'denied',
  },
  [InactiveApplicationStatus.LOAN_OFFER_EXPIRED]: {
    status: 'Expired',
    state: 'denied',
  },
  [InactiveApplicationStatus.APPLICATION_CANCELED]: {
    status: 'Cancelled',
    state: 'denied',
  },
  [InactiveApplicationStatus.LOAN_WITHDRAWN]: {
    status: 'Cancelled',
    state: 'denied',
  },
  [InactiveApplicationStatus.LOAN_CANCELED]: {
    status: 'Cancelled',
    state: 'denied',
  },
  [InactiveApplicationStatus.NOT_ELIGIBLE]: {
    status: 'Ineligible',
    state: 'denied',
  },
  [InactiveApplicationStatus.NON_ELIGIBLE]: {
    status: 'Ineligible',
    state: 'denied',
  },
  [InactiveApplicationStatus.PAID_IN_FULL]: {
    status: 'Paid in Full',
    state: 'completed',
  },
} as const

export enum ApplicationType {
  IN_SCHOOL = 'in_school',
  US_GRAD = 'us_grad',
  REFI = 'refi',
}

export const IN_SCHOOL_APPLICATION_TYPES = [
  ApplicationType.IN_SCHOOL,
  ApplicationType.US_GRAD,
] as const

export const isInSchoolApplicationType = (
  type?: string | null,
): type is (typeof IN_SCHOOL_APPLICATION_TYPES)[number] => {
  if (!type) return false
  return (IN_SCHOOL_APPLICATION_TYPES as readonly string[]).includes(type)
}
export enum ApplicationCardType {
  APPLICATION = 'in_school',
  LOAN = 'loan',
}

export type ApplicationProgressStepInSchool = Exclude<
  ApplicationStep,
  | ApplicationStep.INCOMPLETE_APPLICATION_TAS
  | ApplicationStep.PAYOFF
  | ApplicationStep.PAYOFF_VERIFICATION
  | ApplicationStep.INCOMPLETE_APPLICATION_PREQUAL
  | ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL_ACCEPT
  | ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL_REJECT
>

export type ApplicationProgressStepRefi = Extract<
  ApplicationStep,
  | ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL
  | ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL_REJECT
  | ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL_ACCEPT
  | ApplicationStep.INCOMPLETE_APPLICATION_PREQUAL
  | ApplicationStep.INCOMPLETE_APPLICATION_EDUCATION
  | ApplicationStep.INCOMPLETE_APPLICATION_EMPLOYMENT
  | ApplicationStep.INCOMPLETE_APPLICATION_FINANCE
  | ApplicationStep.INCOMPLETE_APPLICATION_FINAL_SUBMIT
  | ApplicationStep.KICKBACK
  | ApplicationStep.CREDIT_CHECK
  | ApplicationStep.UPLOAD_DOCUMENTS
  | ApplicationStep.RE_UPLOAD_DOCUMENTS
  | ApplicationStep.DOCUMENT_VERIFICATION
  | ApplicationStep.SUPPORT_LETTER
  | ApplicationStep.PAYOFF
  | ApplicationStep.REVIEW_AND_SIGN_LOAN
  | ApplicationStep.FUNDING_IN_PROGRESS
  | ApplicationStep.PAYOFF_VERIFICATION
>

export const APPLICATION_PROGRESS_STEP_IN_SCHOOL: Record<ApplicationProgressStepInSchool, number> =
  {
    [ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL]: 0,
    [ApplicationStep.INCOMPLETE_APPLICATION_EDUCATION]: 0,
    [ApplicationStep.INCOMPLETE_APPLICATION_EMPLOYMENT]: 0,
    [ApplicationStep.INCOMPLETE_APPLICATION_FINANCE]: 0,
    [ApplicationStep.INCOMPLETE_APPLICATION_FINAL_SUBMIT]: 0,
    [ApplicationStep.CONFIRM_LOAN_AMOUNT_PARTIAL]: 1,
    [ApplicationStep.CONFIRM_LOAN_AMOUNT_FULL]: 1,
    [ApplicationStep.CONFIRM_LOAN_AMOUNT_UPSELL]: 1,
    [ApplicationStep.ADDITIONAL_FUNDING]: 2,
    [ApplicationStep.ACADEMIC_PERIOD]: 3,
    [ApplicationStep.UPLOAD_TUITION_BILL]: 3,
    [ApplicationStep.ID_VERIFICATION]: 4,
    [ApplicationStep.KICKBACK]: 4,
    [ApplicationStep.UPLOAD_ADMISSION_LETTER]: 5,
    [ApplicationStep.CREDIT_CHECK]: 6,
    [ApplicationStep.UPLOAD_DOCUMENTS]: 7,
    [ApplicationStep.RE_UPLOAD_DOCUMENTS]: 8,
    [ApplicationStep.DOCUMENT_VERIFICATION]: 9,
    [ApplicationStep.SUPPORT_LETTER]: 10,
    [ApplicationStep.FINAL_REVIEW]: 11,
    [ApplicationStep.ACCEPT_LOAN]: 12,
    [ApplicationStep.ACCEPT_LOAN_TIL]: 12,
    [ApplicationStep.SCHOOL_CERTIFICATION]: 13,
    [ApplicationStep.UPLOAD_VISA]: 14,
    [ApplicationStep.TRANSFER_DOCUMENT]: 14,
    [ApplicationStep.REVIEW_AND_SIGN_LOAN]: 15,
    [ApplicationStep.FINAL_DISCLOSURE]: 16,
    [ApplicationStep.FUNDING_IN_PROGRESS]: 17,
    [ApplicationStep.UPDATE_PROFILE]: 17,
    [ApplicationStep.NOVA_CASHFLOW]: 17,
  }

export const APPLICATION_PROGRESS_STEP_REFI: Record<ApplicationProgressStepRefi, number> = {
  [ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL]: 1,
  [ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL_REJECT]: 1,
  [ApplicationStep.INCOMPLETE_APPLICATION_PERSONAL_ACCEPT]: 1,
  [ApplicationStep.INCOMPLETE_APPLICATION_PREQUAL]: 1,
  [ApplicationStep.INCOMPLETE_APPLICATION_EDUCATION]: 1,
  [ApplicationStep.INCOMPLETE_APPLICATION_EMPLOYMENT]: 1,
  [ApplicationStep.INCOMPLETE_APPLICATION_FINANCE]: 1,
  [ApplicationStep.INCOMPLETE_APPLICATION_FINAL_SUBMIT]: 1,
  [ApplicationStep.CREDIT_CHECK]: 2,
  [ApplicationStep.KICKBACK]: 2,
  [ApplicationStep.UPLOAD_DOCUMENTS]: 3,
  [ApplicationStep.RE_UPLOAD_DOCUMENTS]: 4,
  [ApplicationStep.DOCUMENT_VERIFICATION]: 5,
  [ApplicationStep.SUPPORT_LETTER]: 6,
  [ApplicationStep.PAYOFF]: 7,
  [ApplicationStep.PAYOFF_VERIFICATION]: 8,
  [ApplicationStep.REVIEW_AND_SIGN_LOAN]: 9,
  [ApplicationStep.FUNDING_IN_PROGRESS]: 10,
}

export const paymentModalMessages = {
  usa: {
    text1: 'You are now leaving MPOWER Financing and will be redirected to ',
    text2:
      'to make a payment from an eligible international bank account, debit card, or credit card.',
  },
  canada: {
    text1:
      'Please note if you have a past due payment, you will have to use Flywire to make a one time payment. Autopay through NorthStar can only be used for future payments. \n\nYou are now leaving MPOWER Financing and will be redirected to NorthStar to register for autopay using an eligible Canadian bank account.',
  },
  northstar: {
    text1:
      "You're already enrolled in autopay. Are you sure you want to continue and make an additional payment? \n\nYou are now leaving MPOWER Financing and will be redirected to NorthStar to make a payment from an eligible international bank account, debit card, or credit card.",
    text2:
      'You are now leaving MPOWER Financing and will be redirected to NorthStar to make a payment from an eligible international bank account, debit card, or credit card.',
  },
  flywire: {
    text1:
      "You are now leaving MPOWER Financing and will be redirected to Flywire to make a payment from an eligible international bank account, debit card, or credit card. \n\n You're already enrolled in autopay. Are you sure you want to continue and make an additional payment?",
    text2:
      'You are now leaving MPOWER Financing and will be redirected to Flywire to make a payment from an eligible international bank account, debit card, or credit card.',
    text3: '\n The minimum payment amount supported by Flywire is US$50.',
  },
}

export const paymentUrls = {
  firstmarkUSAPaymentURL: 'https://firstmarkservices.com/',
  launchUSAPaymentURL: 'https://www.launchservicing.com/make-a-payment/',
  canadaPaymentURL: 'https://www.northstarcurrency.com/pad-mpower',
  northstarPaymentURL: 'https://www.northstarcurrency.com/mpower',
}

export const faqQuestionAndAnswers = [
  {
    title: `What visa, career and other benefits <b>do I gain access to by accepting the offer?</b>`,
    answer:
      'After you agree and e-sign your offer, you get access to exclusive benefits from MPOWER including visa support, career and professional support and pre-qualified U.S. credit card and U.S. bank account offers.',
  },
  {
    title: `Can I pay off <b>my loan sooner?</b> `,
    answer:
      'Yes, MPOWER loans have no prepayment penalties! Some students pay more than their monthly principal and interest payment - lowering the total amount of interest paid and the time to repay your loan in full.',
  },
  {
    title: `Can I defer my loan if <b>my visa is delayed or denied?</b>`,
    answer:
      "Yes, e-sign your offer first.\n\nThen, if your visa is delayed, you can defer your loan funds for up to one semester in the future with the same terms. \n\n If you don't get approved for a visa, you can cancel your loan application up until funds are sent to your university, and you will have no further obligation under the agreement.",
  },
  {
    title: `Are there any foreign exchange, insurance or out-of-pocket fees <b>in my MPOWER student loan?</b>`,
    answer:
      "No! \n\n If you are considering another loan offer, look at the other fees - such as insurance, foreign exchange and out-of-pocket application, processing or sanction fees.\n\nMPOWER never charges any of these fees and is often the best choice for international students. MPOWER's origination fee, which is 5% of the disbursed amount, is financed as part of the loan agreement.",
  },
  {
    title: `What should I do if I am accepted at several universities <b>and have an MPOWER loan offer for each?</b>`,
    answer:
      'Congratulations! \n\n You should proceed and e-sign each loan offer. Once you decide which university to enroll in, then upload your visa and contact your MPOWER Relationship Manager to cancel the other loan offers.',
  },
]

export const atilPageModalTexts = {
  schoolPayment: {
    boldText:
      'Pay Less Now vs. More Later: \nMaking In-school Payments Lowers the Interest Owed \n',
    plainText:
      '\nPaying interest while in school lowers your total interest paid over the life of the loan and lowers your post-graduation principal+interest payments. Deferring payments while pursuing studies will increase your total loan amount because interest will capitalize.\n\nAs an example: A student who borrows US$40,000 for a two-year program (25 months of studies) and makes no payments while in school will see US$10,000 of interest accrue by graduation. Interest capitalization will increase the total loan amount to about US$50,000, or by 25%, at a 12% interest rate. Once interest is capitalized into the loan amount, the student pays additional interest on the capitalized amount. In this example, borrowing US$40,000 with full payment deferrals while in school is equivalent to borrowing US$50,000 with an interest-only payment while in school. \n\n Further, making in-school payments will help the student build their U.S. credit history through timely repayment. A credit history helps international students to qualify for credit cards, auto loans and rental screening.',
  },
  monthlyPayment: {
    plainText:
      'MPOWER loans have no repayment penalties. Some students pay more than their monthly principal and interest payment - lowering the total amount of interest paid and the time to repay your loan in full.',
  },
  interestRate: {
    boldText:
      'Interest begins when your funds are received by your university and only on the amount received.',
    plainText:
      '\nAs an example: A student is approved for US$50,000. The first US$25,000 is for the fall semester. Interest begins on the US$25,000 the day it is received by the university at the beginning of the fall semester. For spring, the student needs US$10,000. Again, interest begins on the next US$10,000 only when it is received by the university for spring. At the end of the year, the student has used US$35,000 in funds and is preapproved for US$15,000 to use for the next academic year. \n\nThis significantly reduces the amount you pay in interest! You only pay interest on funds received by your university and only beginning from when they are received, not before.',
  },
}

export const atilPageInfoTipTexts = {
  noVisaYet: {
    title: "Don't have your visa yet?",
    details:
      "Don't worry, you can still accept your loan offer now! If you don't get approved for a visa, you can cancel your loan application anytime before funds are sent to your university, and you will have no further obligation under the agreement.",
  },
  decideUniversity: {
    title: 'Deciding between a few universities? ',
    details:
      'Not an issue! Please continue by agreeing and e-signing each offer. Contact us once you decide on your university.',
  },
}

export const atilPageNewInfoTipTexts = {
  secureFund: {
    title: 'You secure your funds and can cancel anytime before the funds go to your school.',
  },
  noVisaYet: {
    title: 'No visa yet? You can still sign! ',
    details: "If your visa circumstances change, you're not committed to the loan.",
  },
}
export const atilPageEsignLastMonthTexts = {
  title: 'Over 1,000 students e-signed their MPOWER loan agreements last month.',
  highlighter: " Here's why you can be confident signing your agreement today:",
}
export const atilEsignLMBottomTexts = {
  title:
    'Last month, over 1,000 students e-signed - securing education funds to achieve their study abroad dream.',
  highlighter: 'E-sign now to fund your education and live your dream!',
}

export interface ConfirmEmailBannerWrapperDataProps {
  emailConfirmed?: boolean
  emailConfirmationPerformed?: boolean
}

export interface ConfirmEmailBannerWrapperProps {
  data?: ConfirmEmailBannerWrapperDataProps
}
export interface EmailItem {
  id: string
  label: string
  email: string
  isVerified: boolean
  placeHolder: string
  type: string
  savedEmail: string
  reverify: boolean
  isValidEmailEntered?: boolean
  showAsterisk?: boolean
}
export interface AddressItem {
  id: string
  label: string
  placeHolder: string
  value: string
  disabled: boolean
}

export interface PhoneNumberItem {
  id: string
  label: string
  phone: string
  isVerified: boolean
  codeInput: string
  selectedCountryData: string
  phoneNumbers: string
  customError: string
  savedPhoneNo: string
  type: string
  metadata: any
  reverify: boolean
  verificationMode: string
  showAsterisk?: boolean
}

export interface ReferenceItem {
  emailId: string
  emailLabel: string
  email: string
  isEmailVerified: boolean
  emailPlaceholder: string
  type: string
  id: string
  phoneLabel: string
  phone: string
  codeInput: string
  selectedCountryData: string
  phoneNumbers: string
  customPhoneError: string
  savedPhoneNo: string
  isPhoneVerified: boolean
  metadata: any
  savedEmail: string
  verificationMode: string

  name: string
  nameLabel: string
  relationship: string
  relationShipLabel: string
  nameId: string
  relationshipId: string
}

export const PROFILE_EMAIL_SET: EmailItem[] = [
  {
    id: 'primaryEmail',
    label: 'Primary Email',
    email: '',
    isVerified: false,
    placeHolder: 'Enter Primary Email',
    type: 'primary',
    savedEmail: '',
    reverify: false,
    showAsterisk: false,
  },
  {
    id: 'alternateEmail',
    label: 'Alternative Email',
    email: '',
    isVerified: false,
    placeHolder: 'Enter Alternative Email',
    type: 'alternate',
    savedEmail: '',
    reverify: false,
    showAsterisk: false,
  },
  {
    id: 'schoolEmail',
    label: 'School Associated Email',
    email: '',
    isVerified: false,
    placeHolder: 'Enter school associated email',
    type: 'school',
    savedEmail: '',
    reverify: false,
    showAsterisk: false,
  },
]

export const PROFILE_PHONE_SET: PhoneNumberItem[] = [
  {
    id: 'primaryPhone',
    label: 'Primary number',
    phone: '',
    isVerified: false,
    codeInput: '',
    selectedCountryData: '',
    phoneNumbers: '',
    customError: '',
    savedPhoneNo: '',
    type: 'primary',
    metadata: {},
    reverify: false,
    verificationMode: '',
    showAsterisk: false,
  },
  {
    id: 'schoolCountryPhone',
    label: 'US/Canada Phone number',
    phone: '',
    isVerified: false,
    codeInput: '',
    selectedCountryData: '',
    phoneNumbers: '',
    customError: '',
    savedPhoneNo: '',
    type: 'school',
    metadata: {},
    reverify: false,
    verificationMode: '',
    showAsterisk: false,
  },
  {
    id: 'alternatePhone',
    label: 'Whatsapp number',
    phone: '',
    isVerified: true,
    codeInput: '',
    selectedCountryData: '',
    phoneNumbers: '',
    customError: '',
    savedPhoneNo: '',
    type: 'alternate',
    metadata: {},
    reverify: false,
    verificationMode: '',
    showAsterisk: false,
  },
]

export const PROFILE_REFERENCE_SET: ReferenceItem[] = [
  {
    emailId: 'referenceEmail1',
    emailLabel: 'Reference Email',
    email: '',
    isEmailVerified: true,
    emailPlaceholder: 'Enter reference email',
    type: 'reference',
    id: 'referencePhone1',
    phoneLabel: 'Reference Phone number',
    phone: '',
    isPhoneVerified: false,
    codeInput: '',
    selectedCountryData: '',
    phoneNumbers: '',
    customPhoneError: '',
    savedPhoneNo: '',
    savedEmail: '',
    metadata: {},
    verificationMode: '',
    name: '',
    nameLabel: 'Reference Name',
    relationship: '',
    relationShipLabel: 'Reference Relationship',
    nameId: 'refName',
    relationshipId: 'refRelationship',
  },
]
export const AVATAR_MAP: Record<string, string> = {
  'Mr.': '/images/avatarMale.png',
  'Ms./Mrs.': '/images/avatarFemale.png',
}

export interface BenefitItem {
  icon: string
  title: string
  scale: string
}

export interface RepaymentPhase {
  key: 'inSchool' | 'gracePeriod' | 'repayment'
  icon: string
  title: string
  duration: string
  paymentType: string
  description: string
}

export const BENEFITS_ATIL_PNOTE: BenefitItem[] = [
  {
    icon: 'graduation',
    title: 'Free FrogHire subscription for all students to find their dream internship and job.',
    scale: '0.6',
  },
  {
    icon: 'suitecase',
    title: 'Free internship preparation in our Career Launch Bootcamp.',
    scale: '0.6',
  },
  {
    icon: 'flight',
    title: "{US} Visa support with Catalyst Gem's free course.",
    scale: '1',
  },
  {
    icon: 'moneyHandDollar',
    title: '{CAD} Study permit support with Borderpass.',
    scale: '0.45',
  },
  {
    icon: 'monitor',
    title:
      'Start building your U.S. credit history after on-time payments with a free student-focused Zolve credit card.',
    scale: '0.85',
  },
  {
    icon: 'moneyTwoHands',
    title: 'US$300 for every successful referral.',
    scale: '0.5',
  },
]

export const REPAYMENT_PHASES: RepaymentPhase[] = [
  {
    key: 'inSchool',
    icon: 'graduated',
    title: 'In-school period',
    duration: '1st - Graduation month',
    paymentType: 'Interest-only payments',
    description:
      'No need to stress about full payments. Just keep up with interest-only payments while you study.',
  },
  {
    key: 'gracePeriod',
    icon: 'suitecase',
    title: '',
    duration: '',
    paymentType: 'Interest-only payments',
    description: '',
  },
  {
    key: 'repayment',
    icon: 'loanExchange',
    title: '10-year repayment period',
    duration: 'After grace period to end of loan',
    paymentType: 'Principal + interest payments',
    description: 'As your career takes off, you also start making payments towards your principal.',
  },
]

export const INDIA = 'india'
export const ZIMBABWE = 'zimbabwe'
export const VISA_SUPPORT_LETTER_US = [
  'Submit to your school to receive your I-20.',
  'Get free access to a visa preparation course after accepting the loan terms.',
  'Present as valid proof of funds at your visa interview.',
]
export const VISA_SUPPORT_LETTER_CANADA = [
  'Present as valid proof of funds with your visa/study permit application.',
  'Get free access to visa preparation materials after accepting the loan terms.',
]

export interface VideoCardItem {
  id: number
  imageUrl: string
  title: string
  header: string
  subHeader: string
  date: string
  lockMessage: string
  isAvailableToView: boolean
  slidesUrl: string
  duration: string
  videoLink: string
}
export const VIDEOPLAYER_DATA: VideoCardItem[] = [
  {
    id: 1,
    imageUrl: '/images/yudij/yudij1.webp',
    title: 'Bonus session 1 - Is studying in the U.S. still worth it?',
    header: 'Cost vs. ROI ?',
    subHeader: 'Scholarships and OPT, financial aid, H-1B and immigration updates',
    date: '',
    lockMessage: '',
    isAvailableToView: true,
    slidesUrl: 'https://dy93kngv2hjvd.cloudfront.net/public/STUDY-IN-USA-Masters.pdf',
    duration: '01:06:54',
    videoLink: 'https://dy93kngv2hjvd.cloudfront.net/videos/session-1/master.m3u8',
  },
  {
    id: 2,
    imageUrl: '/images/yudij/yudij2.webp',
    title: 'Bonus session 2: Job market',
    header: 'Hottest job trends',
    subHeader: 'What comes after graduation?',
    date: '',
    lockMessage: '',
    isAvailableToView: true,
    slidesUrl: 'https://dy93kngv2hjvd.cloudfront.net/public/YudiJ_Ace_Your_Career_in_2025.pdf',
    duration: '01:00:19',
    videoLink: 'https://dy93kngv2hjvd.cloudfront.net/videos/session-2/master.m3u8',
  },
  {
    id: 3,
    imageUrl: '/images/yudij/yudij3.webp',
    title: 'Bonus session 3: F-1 visa demystified',
    header: 'Visa process explained',
    subHeader: 'Tips to ace your visa interview',
    date: '',
    lockMessage: '',
    isAvailableToView: true,
    slidesUrl:
      'https://dy93kngv2hjvd.cloudfront.net/public/USPolicies_Impacting_InternationalStudents_May_2025.pdf',
    duration: '01:29:47',
    videoLink: 'https://dy93kngv2hjvd.cloudfront.net/videos/session-3/master.m3u8',
  },
  {
    id: 4,
    imageUrl: '/images/yudij/yudij4.webp',
    title: 'Career session 1: Mindset and move prep',
    header: 'Ready to move?',
    subHeader: 'Shift your mindset for success',
    date: '',
    lockMessage: 'Unlock after accepting loan terms',
    isAvailableToView: false,
    slidesUrl: 'https://dy93kngv2hjvd.cloudfront.net/public/Job-Hunting-Career-Bootcamp-copy.pdf',
    duration: '01:06:53',
    videoLink: 'https://dy93kngv2hjvd.cloudfront.net/videos/session-4/master.m3u8',
  },
  {
    id: 5,
    imageUrl: '/images/yudij/yudij5.webp',
    title: 'Career session 2: Campus hustle',
    header: 'On-campus jobs: Where to find them',
    subHeader: 'Make the most of campus career fairs',
    date: '',
    lockMessage: 'Unlock after accepting loan terms',
    isAvailableToView: false,
    slidesUrl: 'https://dy93kngv2hjvd.cloudfront.net/public/Week-2-CAREER-BOOTCAMP.pdf',
    duration: '01:09:33',
    videoLink: 'https://dy93kngv2hjvd.cloudfront.net/videos/session-5/master.m3u8',
  },
  {
    id: 6,
    imageUrl: '/images/yudij/yudij6.webp',
    title: 'Career session 3: Internship game plan',
    header: 'Ideal internship timeline',
    subHeader: 'Resume tips that stand out',
    date: '',
    lockMessage: 'Unlock after accepting loan terms',
    isAvailableToView: false,
    slidesUrl:
      'https://dy93kngv2hjvd.cloudfront.net/public/Week-3-MPOWER-2025-Job-Hunting-Career-Bootcamp.pdf',
    duration: '01:09:36',
    videoLink: 'https://dy93kngv2hjvd.cloudfront.net/videos/session-6/master.m3u8',
  },
  {
    id: 7,
    imageUrl: '/images/yudij/yudij7.webp',
    title: 'Career session 4: Build your personal brand',
    header: 'LinkedIn and portfolio hacks',
    subHeader: 'Strategic networking to land the job',
    date: '',
    lockMessage: 'Unlock after accepting loan terms',
    isAvailableToView: false,
    slidesUrl:
      'https://dy93kngv2hjvd.cloudfront.net/public/Week-4-MPOWER-2025-Job-Hunting-Career-Bootcamp.pdf',
    duration: '01:01:15',
    videoLink: 'https://dy93kngv2hjvd.cloudfront.net/videos/session-7/master.m3u8',
  },
  {
    id: 8,
    imageUrl: '/images/yudij/yudij8.webp',
    title: 'Career session 5: Immigration 101',
    header: 'CPT, OPT, STEM OPT, H-1B and beyond',
    subHeader: 'Your immigration questions answered',
    date: '',
    lockMessage: 'Unlock after accepting loan terms',
    isAvailableToView: false,
    slidesUrl:
      'https://dy93kngv2hjvd.cloudfront.net/public/Week-5-MPOWER-2025-Job-Hunting-Boot-Camp.pdf',
    duration: '01:24:53',
    videoLink: 'https://dy93kngv2hjvd.cloudfront.net/videos/session-8/master.m3u8',
  },
]

export const PHONE_VERIFICATION_TYPES = {
  WHATSAPP: 'whatsapp',
  SMS: 'sms',
  WHATSAPP_AND_SMS: 'whatsapp_and_sms',
}
export const OTP_PURPOSE = {
  VERIFICATION: 'verification',
  REFERENCE_EMAIL_CONFIRMATION: 'ref-email-confirmation',
  CONSENT: 'consent-preference',
  VERIFICATION_WHATSAPP: 'wp-verification',
  REFERENCE_VERIFICATION_WHATSAPP: 'wp-ref-verification',
}

export const OTP_LABEL = {
  WHATSAPP: 'Whatsapp number ',
  SMS: 'SMS number ',
}
export const OTP_CHANNELS = ['whatsapp', 'sms'] as const
export type OtpChannel = (typeof OTP_CHANNELS)[number]

export const REFERENCE_EMAIL_CONFIRMATION_MESSAGE =
  "Thanks! We've sent a verification link to the email address of the reference you provided. They need to click it within 12 hours to complete the verification."
export const REFERENCE_PHONE_CONFIRMATION_MESSAGE =
  "Thanks! We've sent a verification link to the whatsapp number of the reference you provided. They need to click it within 12 hours to complete the verification."

export const CONTACTIBILITY_ERRORS = {
  REFERENCE_EMAIL_SAME_AS_CONTACT_EMAILS: 'Reference email cannot be same as your contact emails',
  CONTACT_EMAIL_SAME_AS_REFERENCE_EMAIL: 'This email cannot be same as reference email',
  REFERENCE_NUMBER_SAME_AS_CONTACT_NUMBERS:
    'Reference number cannot be same as your contact numbers',
  CONTACT_NUMBER_SAME_AS_REFERENCE_NUMBER: 'This number cannot be same as reference number',
  INVALID_EMAIL: 'Please enter a valid email address',
  INVALID_NUMBER: 'Please enter a valid phone number',
  EMAIL_SAME_AS_PRIMARY_EMAIL: 'This email cannot be same as primary email',
  ENTER_VALID_NAME: 'Please enter a valid name.',
  ENTER_VALID_RELATIONSHIP: 'Please enter a valid relationship.',
  EMAIL_CA: 'Email must end with .ca or .edu or .org or .net',
  EMAIL_US: 'Email must end with .edu or .org or .net',
  OTP_MAX_LIMIT_ERROR: 'max_limit_error',
  VERIFY_NUMBER_ERROR: 'Please verify both your phone number and email to continue.',
}
export const OTP_VENDOR_BORROWER_APP = 'borrowerApp'
export const defaultAlternateEmailItem: EmailItem = {
  id: 'alternateEmail',
  label: 'Used as a backup email',
  email: '',
  isVerified: false,
  placeHolder: 'Please enter your alternate email',
  type: 'alternate',
  savedEmail: '',
  reverify: false,
}

export const defaultSchoolEmailItem: EmailItem = {
  id: 'schoolEmail',
  label: 'Helps us verify your enrollment',
  email: '',
  isVerified: false,
  placeHolder: 'Please enter your school associated email',
  type: 'school',
  savedEmail: '',
  reverify: false,
  isValidEmailEntered: false,
}

export const defaultPhoneItem: PhoneNumberItem = {
  id: 'phoneNumber',
  label: 'Used for communication during your application',
  phone: '',
  isVerified: false,
  codeInput: '',
  selectedCountryData: '',
  phoneNumbers: '',
  customError: '',
  savedPhoneNo: '',
  type: 'school',
  metadata: {},
  reverify: false,
  verificationMode: '',
}
export interface LinkedinURLItem {
  id: string
  url: string
  placeHolder: string
  type: string
  showAsterisk?: boolean
}
export const defaultLinkedinItem: LinkedinURLItem = {
  id: 'linkedinURL',
  url: '',
  placeHolder: 'e.g. https://www.linkedin.com/in/your-name',
  type: 'social',
}

export const ELIGIBLE_SCHOOL_COUNTRY = [
  {
    value: '🇨🇦 - +1',
    label: '🇨🇦 - +1',
    key: 'CA',
    code: '1',
    emoji: '🇨🇦',
    name: 'Canada',
    codeWithPlus: '+1',
    codeWithZero: '01',
    codeWithZeroWithPlus: '+01',
    valueWithName: '🇨🇦 - Canada (+1)',
  },
  {
    value: '🇺🇸 - +1',
    label: '🇺🇸 - +1',
    key: 'US',
    code: '1',
    emoji: '🇺🇸',
    name: 'United States',
    codeWithPlus: '+1',
    codeWithZero: '01',
    codeWithZeroWithPlus: '+01',
    valueWithName: '🇺🇸 - United States (+1)',
  },
]

export const LINKEDIN_ERROR =
  'Please enter a valid LinkedIn URL (e.g., https://www.linkedin.com/in/your-name).'
export const OTP_LENGHT = 6
export const EMAIL = 'email'
export const PHONE = 'phone'
export const ISREPEAT_SEM = 'isRepeatSem'
export const ISNOTREPEAT_SEM = 'notRepeatSem'
export const VALID_DOMAIN_FOR_SCHOOL = ['.ca', '.edu', '.org', '.net']
export const SCHOOL = 'school'

export const NOVA_LINK = 'https://static.novacredit.com/connect/v2/init.js'
export const SOCIAL = 'social'
export const LINKEDIN = 'linkedin'
export enum AddressTypes {
  PERMANENT = 'permanent',
  CURRENT = 'current',
}
export const DOCUMENTS_EXCEPTION_LIST = ['I-94']

export const ATIL_APPROVAL_TEXT = `I hereby authorize MPOWER to obtain my I-94 information and documentation on my behalf from the U.S. Department of Homeland Security and/or records about me and my current immigration status that are protected by the Privacy Act of 1974 (5 U.S.C. § 552a); DHS Privacy Act Regulations (6 C.F.R. § 5.21(d)). I hereby acknowledge that my taking of this action is entirely voluntary; and that I am under no obligation to consent to the release of my information to any third party.\n\nI also hereby authorize DHS, its components, offices, employees, contractors, agents, and assignees, to disclose information and records regarding my I-94 and my current immigration status to MPOWER. I understand this may include and is not limited to reports, evaluations, and notes of any kind, contained in any record keeping system maintained by or on behalf of DHS; that DHS retains the discretion to decide if particular records or information are within the scope of this Waiver; and that DHS has no control over how MPOWER will use or disseminate my information. I agree to release and hold harmless DHS, its components, offices, employees, contractors, agents, and assignees, from any and all claims of action or damages of any kind arising from, or in any way connected to, the release or use of any information or records pursuant to this Waiver.\n\nI also understand that I may revoke this Privacy Waiver at any time by contacting the ICE Privacy Office (202-732-3300 or ICEPrivacy@dhs.gov) or the relevant ICE office handling this matter or case.`

export const DOCUMENT_CONSENT_CONFIG: Record<
  string,
  {
    labelText: string
    linkText: string
    modalContent: string
  }
> = {
  'Visa on your passport page': {
    labelText:
      'I authorize MPOWER to verify my U.S. immigration status (I-94) with the U.S. government once I have obtained my immigration document.',
    linkText: 'U.S. immigration status (I-94)',
    modalContent: ATIL_APPROVAL_TEXT,
  },
}
export const I94_CONSENT_LINK_PHRASE = 'I-94 immigration status information'

export const USER_CONSENT_CONFIG: Record<
  string,
  {
    title: string
    consentTextTemplate: (status: boolean, partnerName: string) => string
    accordionConsentTextTemplate: (status: boolean, partnerName: string) => string
    acceptButtonText: string
    declineButtonText: string
    updateButtonText: string
    loadingText: string
  }
> = {
  PARTNER: {
    title: 'Privacy terms',
    consentTextTemplate: (status: boolean, partnerName: string) =>
      `I ${
        status ? 'give' : 'do not give'
      } MPOWER permission to share my information with ${partnerName} to help with my loan application.`,
    accordionConsentTextTemplate: (status: boolean, partnerName: string) =>
      `I ${
        status ? 'do not give' : 'give'
      } MPOWER permission to share my information with ${partnerName} to help with my loan application.`,
    acceptButtonText: 'Agree and continue',
    declineButtonText: 'decline',
    updateButtonText: 'Update privacy',
    loadingText: 'Loading.....',
  },
  I94: {
    title: 'I-94 Privacy terms',
    consentTextTemplate: (status: boolean, partnerName: string) =>
      `I ${
        status ? 'give' : 'do not give'
      } MPOWER permission to access my I-94 immigration status information from the U.S. Government.`,
    accordionConsentTextTemplate: (status: boolean, partnerName: string) =>
      `I ${
        status ? 'do not give' : 'give'
      } MPOWER permission to access my I-94 immigration status information from the U.S. Government.`,
    acceptButtonText: 'Agree and continue',
    declineButtonText: 'decline',
    updateButtonText: 'Update I-94 privacy',
    loadingText: 'Loading.....',
  },
  // Add more consent types here as needed
}
